"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putTransactionSimulation = exports.postTransactionSimulation = exports.postPreSimulation = void 0;
const fetch_1 = require("../fetch");
const postPreSimulation = (data) => (0, fetch_1.fetch)(
// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
(0, fetch_1.requestOption)({
    url: 'transaction/leads',
    method: 'POST',
    data,
}));
exports.postPreSimulation = postPreSimulation;
const postTransactionSimulation = (data) => (0, fetch_1.fetch)(
// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
(0, fetch_1.requestOption)({
    url: 'transaction/simulation',
    method: 'POST',
    data,
}));
exports.postTransactionSimulation = postTransactionSimulation;
const putTransactionSimulation = (data) => {
    return (0, fetch_1.fetch)(
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
    (0, fetch_1.requestOption)({
        url: 'transaction/simulation',
        method: 'PUT',
        data,
    }));
};
exports.putTransactionSimulation = putTransactionSimulation;
//# sourceMappingURL=financial.js.map